// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_9EubX","info-points-wrap":"info-points-wrap_-TfJE","points":"points_V-rX8","text":"text_4hnIc","value":"value_MZMjF"};